<script>
    import SortableTable from '../SortableTable.svelte';
    import Framework from '../../Models/frameworkReferenceModel';
    import Loader from '../Loader.svelte';
import parseFields from '../../Utilities/parseFields';

    let frameworks = Framework.getList();

    let sortFields;
    let items;

    let selected_framework;

    export let cancelAction;
    export let saveAction;

    async function loadFrameworkItems(framework) {
        if (!framework) return


        let framework_model = await Framework.getStatic(framework._id);

        items = [...framework_model.references];
        sortFields = parseFields([...framework_model.fields]).sortFields;
    }


    $: loadFrameworkItems(selected_framework);
</script>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-fullwidth">
        <Loader loading={!$frameworks}>
            <header class="modal-card-head">
                <p class="modal-card-title">Add Item</p>
                <button class="delete" aria-label="close" on:click={cancelAction}></button>
            </header>
            <section class="modal-card-body">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <span class="label">Library</span>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control select is-fullwidth">
                                <select bind:value={selected_framework}>
                                    {#each [...$frameworks] as framework (framework._id)}
                                        <option value={framework}>{framework.name}</option>
                                    {/each}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                {#if sortFields}
                <div>
                    <SortableTable {sortFields} tableData={items} ORM="true" showHideFields={false}>
                        <div slot="rowActions" let:row={item}>
                            <div class="button is-success" on:click={() => saveAction({framework: selected_framework, reference: item.details})}>
                                Add Reference
                            </div>
                        </div>
                    </SortableTable>
                </div>
                {/if}
            </section>
        </Loader>
    </div>
</div>
